import { defineMessages } from 'react-intl'

const messages = defineMessages({
  app_name: 'Smart Dispo',
  dashboard: 'Dashboard',
  about: 'About',
  page_not_found_demo: 'Page not found demo',
  '404': '404',
  warning_404_message: '404 Page not found',
  warning_404_description:
    'We are sorry but the page you are looking for does not exist.',
  settings: 'Settings',
  language: 'Language',
  theme: 'Theme',
  responsive: 'Responsive',
  en: 'English',
  de: 'German',
  bs: 'Bosnian',
  ro: 'Romanian',
  sr: 'Serbian',
  dark: 'Dark',
  light: 'Light',
  ics: 'ICS',
  sign_out: 'Sign out',
  sign_in: 'Sign in',
  sign_up: 'Sign up',
  shipping_company_label: 'Reederei',
  shipping_company_hint: 'Reederei eingeben',
  sign_in_with_google: 'Sign in with Google',
  sign_in_with_facebook: 'Sign in with Facebook',
  sign_in_with_twitter: 'Sign in with Twitter',
  sign_in_with_github: 'Sign in with Github',
  link_with_google: 'Link with Google',
  link_with_facebook: 'Link with Facebook',
  link_with_twitter: 'Link with Twitter',
  link_with_github: 'Link with Github',
  my_account: 'My account',
  name: 'Name',
  email: 'E-Mail',
  password: 'Password',
  confirm_password: 'Confirm Password',
  forgort_password: 'Forgot Password?',
  reset_password: 'Reset Password',
  change_password: 'Change Password',
  change_photo: 'Change Photo',
  change_email: 'Change E-Mail',
  reset_password_hint: 'Enter your E-Mail',
  save: 'Save',
  delete_account: 'Delete account',
  select_file: 'Select file',
  cancel: 'Cancel',
  submit: 'Submit',
  delete: 'Delete',
  ok: 'OK',
  delete_account_dialog_title: 'Delete Account?',
  delete_account_dialog_message:
    'Your account will be deleted and you will lose all your data!',
  email_not_verified: 'E-Mail is not verified!',
  email_verified: 'E-Mail is verified',
  send_verification_email: 'Send verification E-Mail',
  send_verification_email_again: 'Send verification E-Mail again',
  tasks: 'Tasks',
  create_task: 'Create task',
  edit_task: 'Edit task',
  create_vehicle: 'Create vehicle',
  edit_vehicle: 'Edit vehicle',
  users: 'Users',
  edit: 'Edit',
  online: 'Online',
  offline: 'Offline',
  no_connection_warning: 'No connection!',
  title_label: 'Title',
  title_hint: 'Enter title',
  name_label: 'Name',
  name_hint: 'Enter name',
  fin_label: 'FIN',
  fin_hint: 'Enter FIN',
  descriptplaceSelect_labelion_label: 'Description',
  description_hint: 'Enter description',
  vehicle_type_hint: 'Select vehicle type',
  vehicle_type_label: 'Vehicle type',
  hint_autocomplete: 'Search...',
  not_match_found: 'No match found',
  no_connection: 'No connection',
  vehicles: 'Vehicles',
  vehicle_types: 'Vehicle types',
  companies: 'Companies',
  create_company: 'Create company',
  edit_company: 'Edit company',
  full_name_label: 'Full name',
  full_name_hint: 'Enter full name',
  vat_label: 'UID',
  vat_hint: 'Enter UID',
  delete_vehicle_title: 'Delete vehicle?',
  delete_vehicle_message: 'The vehicle will be deleted!',
  delete_vehicle_type_title: 'Delete vehicle?',
  delete_vehicle_type_message: 'The vehicle will be deleted!',
  delete_company_title: 'Delete company?',
  delete_company_message: 'The company will be deleted!',
  driver: 'Driver',
  drivers: 'Drivers',
  create_driver: 'Create driver',
  edit_driver: 'Edit driver',
  delete_driver_title: 'Delete driver type?',
  delete_driver_message: 'The driver  will be deleted!',
  user_hint: 'Select user',
  user_label: 'User',
  container_tasks: 'Container tasks',
  container_task: 'Container task',
  create_container_task: 'Create container task',
  edit_container_task: 'Edit container task',
  delete_container_task_title: 'Delete container task type?',
  delete_container_task_message: 'The container task will be deleted!',
  terminal: 'Terminal',
  terminals: 'Terminals',
  create_terminal: 'Create terminal',
  edit_terminal: 'Edit terminal',
  delete_terminal_title: 'Delete terminal type?',
  delete_terminal_message: 'The terminal  will be deleted!',
  base_data: 'Base date',
  administration: 'Administration',
  company_hint: 'Select company',
  company_label: 'company',
  refNr_hint: 'Enter Reference number',
  refNr_label: 'Reference number',
  conWeight_hint: 'Enter',
  conWeight_label: 'Weight',
  relNr_hint: 'Enter release number',
  relNr_label: 'Release number',
  conNr_hint: 'Enter container number',
  conNr_label: 'Container number',
  sealNr_hint: 'Enter seal number',
  sealNr_label: 'Seal number',
  conSize_label: 'Container size',
  date_label: 'Date',
  date2_label: 'Date2',
  time_label: 'Time',
  driver_hint: 'Select driver',
  driver_label: 'Driver',
  driver2_hint: 'Select driver2',
  driver2_label: 'Driver2',
  vehicle_hint: 'Select vehicle',
  vehicle_label: 'Vehicle',
  vehicle2_hint: 'Select vehicle2',
  vehicle2_label: 'Vehicle2',
  addresses: 'Addresses',
  street_hint: 'Enter street',
  street_label: 'Street',
  zip_hint: 'Enter ZIP code',
  zip_label: 'ZIP',
  place_hint: 'Enter place',
  place_label: 'Place',
  country_hint: 'Enter country',
  country_label: 'Country',
  lat_label: 'Lat',
  lng_label: 'Lng',
  create_address: 'Add address',
  edit_address: 'Edit address',
  delete_address_title: 'Delete address?',
  delete_address_message: 'Address will be deleted!',
  add_address: 'Add address',
  match_hint: 'Match',
  address_hint: 'Select address',
  address_label: 'Address',
  iso_code: 'ISO code',
  iso_code_hint: 'Enter ISO code',
  iso_code_label: 'ISO code',
  iso_code_3: 'ISO-3 code',
  iso_code_3_hint: 'Enter ISO-3 code',
  iso_code_3_label: 'ISO-3 code',
  dialing_code: 'Dialing code',
  dialing_code_hint: 'Enter dialing code',
  dialing_code_label: 'Dialing code',
  is_Eu: 'EU member state',
  is_Eu_label: 'EU member state',
  new_place: 'New place',
  places: 'Places',
  countries: 'Countries',
  edit_country: 'Edit country',
  create_country: 'Create country',
  delete_country_title: 'Delete country?',
  delete_country_message: 'Country will be deleted!',
  delete_place: 'Delete place',
  edit_place: 'Edit place',
  create_place: 'Create place',
  delete_place_title: 'Delete place?',
  delete_place_message: 'Place will be deleted!',
  enable_screen_share: 'Enable multimonitor',
  disable_screen_share: 'Disable multimonitor',
  select_label: 'Select',
  import_label: 'Import',
  export_label: 'Export',
  swap_addresses: 'Swap addresses',
  delete_address: 'Delete address',
  placeSelect_hint: 'Select place',
  open_filter: 'Open filter',
  close_filter: 'Close filter',
  filter: 'Filter',
  select_field: 'Select field',
  sorting: 'Sorting',
  date_picker_text: 'Pick Date',
  time_label_text: 'Time',
  time_picker_text: 'Pick time',
  add_filter: 'Add filter',
  filters: 'Filters',
  operator_like_label: 'like',
  operator_notlike_label: 'not like',
  operator_equal_label: 'equal',
  operator_notequal_label: 'not equal',
  operator_novalue_label: 'no value',
  change_sort_orientation: 'Change sorting',
  delete_filter: 'Delete filter',
  conSize_hint: 'Enter container size',
  pin_hint: 'PIN eingeben',
  pin_label: 'PIN',
  time_of_day_hint: 'Choose time of day',
  time_of_day_label: 'time of day',
  out_hint: 'Enter out',
  out_label: 'Out',
  retNr_hint: 'Enter retNr',
  retNr_label: 'retNr',
  turnIn_hint: 'Enter turnIn',
  dangerousGoods_label: 'Dangerous goods',
  heavy_label: 'heavy transport',
  unsaddle_label: 'unsaddle',
  opened_label: 'opened',
  retrieved_label: 'retrieved',
  eDuty_label: 'E-Zoll',
  aviso_label: 'Aviso',
  turnIn_label: 'TurnIn',
  customer_label: 'Customer',
  customer_hint: 'Choose customer',
  boat_hint: 'Enter boat',
  boat_label: 'Boat',
  port_hint: 'Enter port',
  port_label: 'Port',
  load_hint: 'Enter load',
  load_label: 'Load',
  bRef_hint: 'Enter B-Ref',
  bRef_label: 'B-Ref',
  atNum_label: 'AT',
  atTxt_hint: 'Enter AT',
  atTxt_label: 'AT',
  delete_time_of_day_title: 'Delete time of day?',
  delete_time_of_day_message: 'Time of day will be deleted!',
  times_of_day: 'Times of day',
  delete_time_of_day: 'Delete time of day',
  edit_time_of_day: 'Edit time of day',
  create_time_of_day: 'Create time of day',
  enable_case_sensitivity: 'Enable case sensitivity',
  disable_case_sensitivity: 'Disable case sensitivity',
  enter_query_text: 'Enter search text',
  color_pick_label: 'Choose color',
  current_locale: 'en-US',
  is_allowed_dangerousGoods_label: 'Is allowed to transport dangerous goods',
  is_allowed_heavy_hint: 'Is allowed to transport heavy goods',
  driver_warning_title: 'Driver not allowed!',
  driver_warning_message:
    'Warning! One or more drivers are not allowed to deliver the goods!',
  error_required_field: 'Required field',
  error_wrong_container_number: 'Invalid containernummer',
  grants: 'Grants',
  roles: 'Roles',
  create_role: 'Create role',
  edit_role: 'Edit role',
  delete_role_title: 'Delete role?',
  delete_role_message: 'Role will be deleted!',
  grant_hint: 'Choose grant',
  delete_grant: 'Delete grant',
  add_grant: 'Add grant',
  edit_grant: 'Edit grant',
  create_grant: 'Create grant',
  delete_grant_title: 'Delete grant?',
  delete_grant_message: 'Grant will be deleted!',
  value_label: 'Value',
  value_hint: 'Enter value',
  email_label: 'E-Mail',
  email_hint: 'Enter eEMail',
  edit_user: 'Edit user',
  is_admin_label: 'Administrator',
  container_task_statuses: 'Task statuses',
  edit_container_task_status: 'Edit task status',
  create_container_task_status: 'Create task status',
  delete_container_task_status_title: 'Delete task status?',
  delete_container_task_status_message: 'Task status will be deleted!',
  select_terminal: 'Select terminal',
  select_status: 'Select status',
  allow_create_label: 'Allow create',
  products: 'Products',
  delete_product_message: 'Product will be deleted!',
  delete_product_title: 'Delete product?',
  edit_product: 'Edit product',
  create_product: 'Create product',
  billing: 'billing',
  index_hint: 'Enter index',
  index_label: 'Index',
  prices: 'Prices',
  delete_price_title: 'Delete price?',
  delete_price_message: 'Price will be deleted!',
  price_hint: 'Enter price',
  price_label: 'Price',
  product_label: 'Product',
  product_hint: 'Enter product',
  container_task_price_hint: 'Enter price',
  container_task_price_label: 'Price',
  create_container_task_price: 'Create price',
  edit_container_task_price: 'Edit price',
  delete_container_task_price: 'Delete price',
  delete_container_task_price_title: 'Delete price?',
  delete_container_task_price_message: 'Price will be deleted!',
  unit_price_hint: 'Enter unit price',
  unit_price_label: 'Unit price',
  amount_hint: 'Enter amount',
  amount_label: 'Amount',
  subcontractor_label: 'Subcontractor',
  subcontractor_hint: 'Enter subcontractor',
  next_step: 'Next step',
  documents: 'Documents',
  document_types: 'Document types',
  edit_document_type: 'Edit document type',
  create_document_type: 'Create document type',
  delete_document_type_title: 'Delete document type?',
  delete_document_type_message: 'Document type will be deleted!',
  my_tasks: 'Tasks',
  my_menu: 'My menu',
  archive: 'Tasks archive',
  container_transport: 'Containertransport',
  send_to_driver: 'Send to driver',
  document_type_label: 'Document type',
  document_type_hint: 'Choose document type',
  drop_or_select_file_label: 'Drop or select file',
  download_tooltip: 'Download',
  delete_container_task_file_title: 'Delete file?',
  delete_container_task_file_message: 'File will be deleted!',
  edit_container_task_file: 'Edit file',
  edit_driver_task: 'Edit driver task',
  cmr_label: 'CMR',
  delete_container_task_status_workflow_title: 'Delete workflow?',
  delete_container_task_status_workflow_message: 'Workflow will be deleted!',
  edit_container_task_status_workflow: 'Edit workflow',
  create_container_task_status_workflow: 'Create workflow',
  conNrCheck_label: 'Containernumber check',
  inputName_hint: 'Enter name',
  inputName_label: 'Inputfield-name',
  inputLabel_hint: 'Enter label',
  inputLabel_label: 'Inputfield-Label',
  inputHint_hint: 'Enter hint',
  inputHint_label: 'Inputfield-Hint',
  driver_task: 'Task',
  match2_label: 'Match2',
  chats: 'Chats',
  edit_driver_task_workflow: 'Edit workflow',
  create_driver_task_workflow: 'Create workflow',
  delete_driver_task_workflow_title: 'Delete workflow?',
  delete_driver_task_workflow_message: 'Workflow will be deleted!',
  driver_task_workflows: 'Workflows',
  continue: 'Continue',
  public_chats: 'Public chats',
  is_unsaddled: 'Is unsaddled?',
  finish_task: 'Finish task',
  'link_with_google.com': 'Link with Google',
  'link_with_facebook.com': 'Link with Facebook',
  import: 'Import',
  export: 'Export',
  fieldValue_label: 'Value',
  fieldValue_hint: 'Enter value',
  fieldName_label: 'Field-name',
  fieldName_hint: 'Enter field-name',
  refresh: 'Refresh',
  create_container_task_pdf: 'Create transport task pdf',
  download_cmr: 'Download CMR',
  send_message: 'Send message',
  close: 'Close',
  select_user: 'Select user',
  my_location: 'My location:',
  predefined_messages: 'Predefined messages',
  delete_predefined_chat_message_title: 'Delete predefined message?',
  delete_predefined_chat_message_message: 'Predefined message will be deleted!',
  edit_contact: 'Edit contact',
  delete_contact_title: 'Delete contact?',
  delete_contact_message: 'Contact will be deleted!',
  contacts: 'Contacts',
  create_contact: 'Create contact',
  firstName_label: 'First name',
  firstName_hint: 'Enter first name',
  lastName_label: 'Last name',
  lastName_hint: 'Enter last name',
  skype_label: 'Skype',
  skype_hint: 'Enter skype',
  load_more_label: 'More...',
  write_message_hint: 'Message...',
  changes_not_saved_warning: 'Changes not saved!',
  terminal_notifications: 'Terminal notifications',
  contact_person_label: 'Contact person',
  contact_person_hint: 'Choose contact person',
  contact_persons: 'Contact persons',
  standard_label: 'Standard contact',
  select_operator: 'Select operator',
  truck_label: 'Truck',
  truck_hint: 'Choose truck',
  trailer_label: 'Trailer',
  trailer_hint: 'Choose trailer',
  delete_contact: 'Delete contact',
  relCheck_label: 'Check release number',
  conCheck_label: 'Check container number',
  toggle_multiSelect: 'Select tasks',
  copy: 'Copy',
  foto_uploaded_successfully: 'Foto was uploaded successfully!',
  click_to_upload: 'Click here to upload foto',
  skip: 'Skip',
  file_type: 'File type',
  info_label: 'Info',
  input_label: 'Input',
  foto_label: 'Foto',
  is_mandatory: 'Mandatory',
  turnInCheck_label: 'Check turnIn',
  relNrCheck_label: 'Check release number',
  select_all: 'Select all',
  multiselect_actions: 'actions',
  personal_files: 'Documents',
  edit_personal_file: 'Edit document',
  delete_personal_file_title: 'Delete document?',
  delete_personal_file_message: 'Document will be deleted!',
  delete_container_tasks_title: 'Delete tasks?',
  delete_container_tasks_message: 'Tasks will be deleted!',
  signature_label: 'Signature',
  is_import_label: 'Import',
  is_execution_label: 'Execution',
  mass_emails: 'Mass E-Mails',
  edit_mass_email: 'Edit mass e-mail',
  create_mass_email: 'Create mass e-mail',
  delete_mass_email_title: 'Delete mass e-mail?',
  delete_mass_email_message: 'Mass e-mail will be deleted',
  subject_label: 'Subject',
  body_label: 'Body',
  emails_label: 'E-mail addresses',
  subject_hint: 'Enter subject',
  body_hint: 'Enter body',
  emails_hint: 'Enter e-mail addresses',
  copy_and_go_into: 'Copy and enter',
  import_export: 'Import/Export',
  container_task_requests: 'Containertask requests',
  accept_label: 'Accept',
  deny_label: 'Deny',
  canceled_label: 'Canceled',
  signature_wait: 'This process could take a few minutes. Please wait!',
  clear: 'Clear',
  save_price_label: 'Save price',
  data: 'Data',
  max_file_size: 'You have exceeded the maximum file size!',
  search: 'Search',
  change_log: 'Change log',
  select_path: 'Select log',
  send_cmr_also: 'Also send CMR to the following e-mail:',
  is_cost_label: 'Costs',
  open_label: 'Open',
  is_not_driver_label: 'No driver',
  driverVisable_label: 'Visable for driver',
  countryShort_hint: 'Enter country code',
  countryShort_label: 'Country code',
  comment_label: 'Comment',
  isSplit_label: 'Split',
  split_label: 'Split',
  notifications: 'Notifications',
  driver_task_files: 'Documents',
  vehicleSelection_label: 'Vehicle selection',
  overwrite_label: 'Overwrite',
  onlySecondDriver_label: 'Only for second driver',
  mark_all_notifications_as_read: 'Mark all as read',
  personal_files_users: 'Personal documents',
  checks_label: 'Checks',
  checks_hint: 'Choose checks',
  delete_company_contact_message: 'Contact will be deleted!',
  delete_company_contact_title: 'Delete contact?',
  edit_company_contact: 'Edit contact',
  create_company_contact: 'Create contact',
  customer_tasks: 'Tasks',
  isLock_label: 'Lock other tasks',
  previous_step: 'Previouse step',
  loadRef_label: 'LoadRef',
  loadRef_hint: 'Enter LoadRef',
  my_tasks_archive: 'My Archiv',
  month: 'Month',
  week: 'Woche',
  day: 'Day',
  agenda: 'List',
  next_week: 'Previous month',
  previous_week: 'Next month',
  today: 'Today',
  container_planning: 'Containerplanning',
  date: 'Date',
  time: 'Time',
  container: 'Container',
  edit_container_planning_event: 'Edit entry',
  delete_event_title: 'Delete entry?',
  delete_event_message: 'Entry will be deleted!',
  startTime_label_text: 'Start',
  endTime_label_text: 'End',
  Notes_hint: 'Enter Note',
  Notes_label: 'Note',
  more: 'more',
  is_export_label: 'Export',
  retry: 'Retry',
  error_label: 'Error',
  export_nr: 'ExportNr',
  toggle_report_drawer: 'Open Reports',
  count_reports: 'Counter',
  from_label: 'From',
  from_hint: 'Enter from name',
  replyTo_label: 'Reply to',
  replyTo_hint: 'Enter reply to email',
  isRefrigerated_label: 'Refrigerated transport',
  ocr_hint: 'Recognized text',
  ocr_label: 'Recognized text',
  keywords_hint: 'Keywords',
  keywords_label: 'Keywords',
  driver_task_error_title_kaywordsNotIncluded: 'Foto not clear',
  driver_task_error_message_kaywordsNotIncluded:
    'The words {data} are not recognisable! Take the picture again.',
  driver_task_error_title_undefined: 'Foto not clear',
  driver_task_error_message_undefined:
    'The words {data} are not recognisable! Take the picture again.',
  error_name_exists: 'This name already exists!',
  subcontractor: 'Subcontractor',
  company: 'Company',
  puma_excel_export: 'Puma excel export',
  cost: 'Cost',
  earnings: 'Earnings',
  number_of_tasks: 'Number of tasks',
  calendar_week: 'CW',
  recount_statistics: 'Recount statistics',
  resource_warining_title: 'Resource-heavy!',
  resource_warining_message:
    'Attention! This operation is very resource heavy.',
  staff: 'Staff',
  staffs: 'Staff',
  edit_staff: 'Edit Staff',
  create_staff: 'Create Staff',
  delete_staff_title: 'Delete Staff?',
  delete_staff_message: 'Staff will be deleted!',
  first_name_hint: 'Enter first name',
  first_name_label: 'First name',
  last_name_hint: 'Enter last name',
  last_name_label: 'Last name',
  receiver_hint: 'Enter receiver',
  receiver_label: 'Receiver',
  second_name_hint: 'Enter second name',
  second_name_label: 'Second name',
  passport_number_hint: 'Enter passport Nr',
  passport_number_label: 'Passport Nr',
  birthdate_label: 'Birthdate',
  birth_place_label: 'Borthplace',
  birth_place_hint: 'Enter birth place',
  nationality_label: 'Nationality',
  nationality_hint: 'Enter nationality',
  confesion_label: 'Confession',
  confesion_hint: 'Enter confession',
  marital_date_label: 'Marital date',
  marital_status_label: 'Marital status',
  marital_status_hint: 'Enter marital status',
  registered_label: 'Registered',
  deregistered_label: 'Deregistered',
  all_label: 'All',
  own_label: 'Own',
  isOwn_label: 'Own',
  edit_staff_file: 'Edit staff file',
  add_staff_files: 'Add staff files',
  delete_staff_file_title: 'Delete staff file?',
  delete_staff_file_message: 'Staff file will be deleted!',
  cmrAddress1_label: 'CMR1',
  cmrAddress2_label: 'CMR2',
  edit_staff_salary: 'Edit staff salary',
  delete_staff_salary_title: 'Delete staff salary?',
  delete_staff_salary_message: 'Staff salary will be deleted!',
  active_label: 'Active',
  netto_salary_hint: 'Enter netto salary',
  netto_salary_label: 'Netto salary',
  brutto_salary_hint: 'Enter Brutto salary',
  brutto_salary_label: 'Brutto salary',
  transfer_hint: 'Enter transfer',
  transfer_label: 'Transfer',
  cash_payment_hint: 'Enter cash payment',
  cash_payment_label: 'Cash payment',
  show_label: 'Is shown',
  container_task_statistics: 'Statistics',
  departments: 'Departments',
  department: 'Department',
  create_department: 'Create department',
  edit_department: 'Edit department',
  delete_department_title: 'Delete department?',
  delete_department_message: 'Department will be deleted!',
  registrations: 'Registrations',
  registration_types: 'Registrations',
  registration_type: 'Registration',
  create_registration_type: 'Create registration',
  edit_registration_type: 'Edit registration',
  delete_registration_type_title: 'Delete registration?',
  delete_registration_type_message: 'Registration will be deleted!',
  staff_registrations: 'Staff-registrations',
  staff_registration: 'Staff-registration',
  create_staff_registration: 'Create staff-registration',
  edit_staff_registration: 'Edit staff-registration',
  delete_staff_registration_title: 'Delete staff-registration?',
  delete_staff_registration_message: 'Staff-registration will be deleted!',
  registration_date: 'Registration date',
  unregistration_date: 'Unregistration date',
  probation_date: 'Probation date',
  vacation_days_label: 'Vacation days',
  vacation_days_hint: 'Enter vacation days',
  add_new_row: 'Add',
  old_street_label: 'Street old',
  old_place_label: 'Place old',
  old_zip_label: 'Zip old',
  old_country_label: 'Country old',
  office_phone_hint: 'Enter office phone number',
  office_phone_label: 'Office phone number',
  private_phone_hint: 'Enter private phone number',
  private_phone_label: 'Private phone number',
  wage_data: 'Wage data',
  drivers_licences: 'Driver licences',
  invalid_bic: 'Invalid BIC',
  invalid_iban: 'Invalid IBAN',
  delete_entry_title: 'Delete entry?',
  delete_entry_message: 'Entry will be deleted!',
  staff_calendar: 'Calendar',
  contract_end_date_label: 'Contract end',
  select_calendar_events: 'Select events',
  view: 'View',
  birthdays: 'Birthdays',
  contract_ends: 'Contract ends',
  austrian_holidays: 'Austrian holidays',
  german_holidays: 'German holidays',
  list_month: 'Month list',
  family: 'Family',
  boss_label: 'Boss',
  boss_hint: 'Choose boss',
  vacation_type_label: 'Type',
  vacation_type_hint: 'Choose type',
  whole_day_label: 'Whole day',
  half_day_label: 'Half day',
  create_staff_vacation: 'Create vacation',
  edit_staff_vacation: 'Edit vacation',
  vacation: 'Vacation',
  correction: 'Correction',
  delete_staff_vacation_title: 'Delete vacation?',
  delete_staff_vacation_message: 'Vacation will be deleted!',
  ill: 'Ill',
  consultation: 'Consultation',
  unpaid_vacation: 'Unpaid vacation',
  absence_type_label: 'Absence type',
  absence_type_hint: 'Choose absence type',
  edit_staff_absence: 'Edit absence',
  delete_staff_absence_title: 'Delete absence?',
  delete_staff_absence_message: 'Absence will be deleted!',
  from_time_label_text: 'From',
  to_time_label_text: 'To',
  grant_edit_families: 'Edit families',
  grant_read_families: 'Read families',
  completeContainerTask_label: 'Complete task',
  pink: 'Pink',
  customerVisible_label: 'Visible for customer',
  isTrash_label: 'Trash',
  is_allowed_can45ft_hint: 'Can drive 45ft containers',
  unsaddleSection_label: 'Unsaddle',
  cmr_name_label: 'Customer name',
  controlled_label: 'Controlled',
  renting: 'Renting',
  edit_rent: 'Edit rent',
  delete_rent_message: 'Rent will be deleted!',
  delete_rent_title: 'Delete rent?',
  start_date_label: 'Start',
  end_date_label: 'End',
  delete_renting_price_message: 'Price will be deleted!',
  delete_renting_price_title: 'Delete price?',
  ar_number_label: 'AR-Number',
  type_label: 'Type',
  type_hint: 'Choose type',
  status_label: 'Status',
  download: 'Download',
  start: 'Start',
  end: 'End',
  writeCMR_label: 'Write CMR',
  writeCMR_warning: 'Write CMR!!!',
  delete_driver_task_title: 'Delete task?',
  delete_driver_task_message: 'Task will be deleted!',
  is_finished_label: 'Finished',
  restricted_transferability_label: 'Restricted transferability',
  initial_registration_date_label: 'Initial registration',
  leasing_end_date_label: 'Leasing end',
  return_label: 'Return',
  error_already_rented: 'Vehicle already rented!',
  container_tasks_description: 'Tasks for dispachers',
  customer_tasks_description: 'Tasks for witch customers have access',
  my_tasks_description: 'My tasks to drive',
  chats_description: 'Chat will all users of the app',
  personal_files_description: 'Files related to all my tasks',
  my_tasks_archive_description: 'Archive of all my tasks',
  drivers_description: 'Manage all drivers',
  companies_description: 'Manage all companies',
  addresses_description: 'Manage all addresses',
  vehicles_description: 'Manage all vehicles',
  renter_label: 'Renter',
  renter_hint: 'Enter renter',
  datamanagement: 'Datamanagement',
  warehouses: 'Warehouses',
  create_warehouse: 'Create warehouse',
  edit_warehouse: 'Edit warehouse',
  delete_warehouse_title: 'Delete warehouse?',
  delete_warehouse_message: "Warehouse and all it's data will be deleted!",
  units: 'Units',
  create_unit: 'Create unit',
  edit_unit: 'Edit unit',
  delete_unit_title: 'Delete unit?',
  delete_unit_message: "Unit and all it's data will be deleted!",
  clients: 'Clients',
  create_client: 'Create client',
  edit_client: 'Edit client',
  delete_client_title: 'Delete client?',
  delete_client_message: "Client and all it's data will be deleted!",
  client_data: 'Client data',
  items: 'Items',
  create_item: 'Create item',
  edit_item: 'Edit item',
  delete_item_title: 'Delete item?',
  delete_item_message: "Item and all it's data will be deleted!",
  trucks: 'Trucks',
  create_truck: 'Create truck',
  edit_truck: 'Edit truck',
  delete_truck_title: 'Delete truck?',
  delete_truck_message: "Truck and all it's data will be deleted!",
  create_task_type: 'Create task type',
  edit_task_type: 'Edit task type',
  delete_task_type_title: 'Delete task type?',
  delete_task_type_message: "Task type and all it's data will be deleted!",
  task_types: 'Task types',
  create_warehouse_task_workflow: 'Create workflow',
  edit_warehouse_task_workflow: 'Edit rowkflow',
  delete_warehouse_task_workflow_title: 'Delete workflow?',
  delete_warehouse_task_workflow_message:
    "Workflow and all it's data will be deleted!",
  warehouse_task_workflows: 'Workflows',
  select_client: 'Select client',
  user_clients: 'My clients',
  warehouse_tasks: 'Warehouse tasks',
  create_warehouse_task: 'Create warehouse task',
  edit_warehouse_task: 'Edit warehouse task',
  delete_warehouse_task_title: 'Delete warehouse task?',
  delete_warehouse_task_message:
    "Warehouse task and all it's data will be deleted!",
  taskNr_label: 'Task number',
  orderNr_label: 'Order number',
  taskType_label: 'Task type',
  warehouse_task_content: 'Entities',
  add: 'Add',
  sscc_label: 'SSCC',
  unit_label: 'Unit',
  warehouse_label: 'Warehouse',
  code93_label: 'Code 93',
  code94_label: 'Code 94',
  warehouse_task_movements: 'Movements',
  create_warehouse_task_movement: 'Create movement',
  edit_warehouse_task_movement: 'Edit movement',
  delete_warehouse_task_movement_title: 'Delete movement?',
  delete_warehouse_task_movement_message:
    "Movement and all it's data will be deleted!",
  delete_WTMSelectedRow_title: 'Delete selected movements?',
  delete_WTMSelectedRow_message:
    "Selected Movements and all thei're data will be deleted!",
  delete_WTMRow_title: 'Delete movement?',
  delete_WTMRow_message: "Movement and all it's data will be deleted!",
  delete_all: 'Delete all',
  isControlled_label: 'Controlled',
  pitch_label: 'Pitch',
  code_93_label: 'Code 93',
  code_94_label: 'Code 94',
  nettoWeight_label: 'Netto Weight',
  quantity_label: 'Quantity',
  item_label: 'Item',
  itemUnit_label: 'Item unit',
  charge_label: 'Charge',
  bestBeforeDate_label: 'BBD',
  contentQuantity_label: 'Content quantity',
  contentNettoWeight_label: 'Content netto weight',
  multiMode_label: 'Multiple',
  singleMode_label: 'Single',
  delete_WTMCSelectedRow_title: 'Delete selected movements?',
  delete_WTMCSelectedRow_message:
    "Selected Movements and all thei're data will be deleted!",
  delete_WTMCRow_title: 'Delete movement?',
  delete_WTMCRow_message: "Movement and all it's data will be deleted!",
  next: 'Next',
  back: 'Back',
  from_date_label: 'From',
  currentStep_label: 'Step',
  operator_contains_label: 'contains',
  isMultymode_label: 'Multymode',
  next_label: 'Next',
  add_label: 'Add',
  item_quantity_label: 'Item quantity',
  trailers: 'Trailers',
  create_trailer: 'Create trailer',
  edit_trailer: 'Edit trailer',
  delete_trailer_title: 'Delete trailer?',
  delete_trailer_message: "Trailer and all it's data will be deleted!",
  evaluation: 'Evaluation',
  stock: 'Stock',
  number_label: 'Number',
  pitches_label: 'Pitches',
  recalculate_from_date: 'Recalculate from this date',
  recalculate_for_date: 'Recalculate',
  delivery_note: 'Delivery note',
  barcode_type: 'Barcode Type',
  isLandscape_label: 'Double',
  sum_field_hint: 'Enter sum-fields',
  sum_field_label: 'Sum-fields',
  container_number_label: 'Container number',
  container_size_label: 'Container size',
  seal_number_label: 'Seal number',
  release_number_label: 'Release number',
  tara_label: 'Tara',
  lot_label: 'Lot',
  charge_report: 'Charge report',
  input_date: 'Input date',
  input_task: 'Input task',
  output_date: 'Output date',
  output_task: 'Output task',
  total: 'Total',
  item_number_label: 'Item number',
  quantity_total_label: 'Quantity total',
  excel_download: 'Download excel',
  warehouse_price: 'Warehouse price',
  edit_warehouse_price: 'Edit warehouse price',
  warehouse_price_label: 'Warehouse price',
  default_handling_price_label: 'Default handling price',
  default_stuffing_price_label: 'Default stuffing price',
  flat_label: 'Flat',
  delete_warehouse_price_title: 'Delete warehouse price?',
  delete_warehouse_price_message: 'Warehouse price will be deleted!',
  hide_zeroes: 'Hide zeroes',
  billing_report: 'Billing',
  separator: 'Typ',
  hs_total: 'HS Total',
  stock_total: 'Stock Total',
  handling: 'Handling',
  stuffing: 'Stuffing',
  delete_warehouse_tasks_title: 'Delete selected tasks?',
  delete_warehouse_tasks_message: 'Selected tasks will be deleted!',
  nr: 'Nr',
  from: 'From',
  to: 'To',
  days: 'Days',
  weeks: 'Weeks',
  taskPrice_label: 'Task price',
  chargePrice_label: 'Charge price',
  minWeeks_label: 'Min weeks',
  barcodes: 'Barcodes',
  csv_export: 'CSV Export',
  csv_import: 'CSV Import',
  generate_sscc: 'generate SSCC',
  handling_price_label: 'Handling price',
  stuffing_price_label: 'Stuffing price',
  edit_movement_price: 'Edit movement price',
  initial_stock: 'Initial stock',
  subtotal: 'Subtotal',
  input: 'Input',
  output: 'Output',
  pdf_download: 'PDF Download',
  report: 'Report',
  refresh_calculation: 'Refresh Calculation',
  wek_label: 'WEK',
  lsk_label: 'LSK',
  stock_price: 'Stock price',
  hs_input: 'Handling input',
  hs_output: 'Handling output',
  isGenerateSSCC_label: 'Generate SSCC',
  isGrouped: 'Details',
  isPicked_label: 'Picking',
  unloadingDate_label: 'Unloading',

  grant_create_vehicle: 'Create vehicles',
  grant_create_vehicle_type: 'Create vehicle types',
  grant_create_driver: 'Create drivers',
  grant_create_company: 'Create companies',
  grant_create_country: 'Create countries',
  grant_create_place: 'Create places',
  grant_create_address: 'Create addresses',
  grant_create_time_of_day: 'Create times of day',
  grant_create_terminal: 'Create terminals',
  grant_create_container_task: 'Create container tasks',
  grant_create_container_task_status: 'Create task statuses',
  grant_create_product: 'Create products',
  grant_edit_vehicle: 'Edit vehicles',
  grant_edit_vehicle_type: 'Edit vehicle types',
  grant_edit_driver: 'Edit drivers',
  grant_edit_company: 'Edit companies',
  grant_edit_country: 'Edit countries',
  grant_edit_place: 'Edit places',
  grant_edit_address: 'Edit addresses',
  grant_edit_time_of_day: 'Edit times of day',
  grant_edit_terminal: 'Edit terminals',
  grant_edit_container_task: 'Edit container tasks',
  grant_edit_container_task_status: 'Edit task statuses',
  grant_edit_product: 'Edit products',
  grant_delete_vehicle: 'Delete vehicles',
  grant_delete_vehicle_type: 'Delete vehicle types',
  grant_delete_driver: 'Delete drivers',
  grant_delete_company: 'Delete companies',
  grant_delete_country: 'Delete countries',
  grant_delete_place: 'Delete places',
  grant_delete_address: 'Delete addresses',
  grant_delete_time_of_day: 'Delete times of day',
  grant_delete_terminal: 'Delete terminals',
  grant_delete_container_task: 'Delete container tasks',
  grant_delete_container_task_status: 'Delete task statuses',
  grant_delete_product: 'Delete products',
  grant_read_vehicles: 'Read vehicles',
  grant_read_vehicle_types: 'Read vehicle types',
  grant_read_drivers: 'Read drivers',
  grant_read_companies: 'Read companies',
  grant_read_countries: 'Read countries',
  grant_read_places: 'Read places',
  grant_read_addresses: 'Read addresses',
  grant_read_times_of_day: 'Read times of day',
  grant_read_terminals: 'Read terminals',
  grant_read_container_tasks: 'Read container tasks',
  grant_read_container_task_statuses: 'Read task statuses',
  grant_read_products: 'Read products',
  grant_create_prices: 'Create prices',
  grant_edit_prices: 'Edit prices',
  grant_delete_prices: 'Delete prices',
  grant_read_prices: 'Read prices',
  grant_create_container_task_price: 'Create price',
  grant_edit_container_task_price: 'Edit price',
  grant_delete_container_task_price: 'Delete price',
  grant_read_container_task_prices: 'Read prices',
  grant_read_container_task_files: 'Read documents',
  grant_create_container_task_file: 'Create documents',
  grant_edit_container_task_file: 'Edit documents',
  grant_delete_container_task_file: 'Delete documents',
  grant_read_container_task_status_workflows: 'Read container task workflows',
  grant_create_container_task_status_workflow:
    'Create container task workflows',
  grant_edit_container_task_status_workflow: 'Edit container task workflows',
  grant_delete_container_task_status_workflow:
    'Delete container task workflows',
  grant_read_driver_task_workflows: 'Read driver task workflows',
  grant_create_driver_task_workflow: 'Create driver task workflows',
  grant_edit_driver_task_workflow: 'Edit driver task workflows',
  grant_delete_driver_task_workflow: 'Delete driver task workflows',
  grant_read_driver_task_workflow_statuses: 'Read driver task workflow status',
  grant_create_driver_task_workflow_status:
    'Create driver task workflow status',
  grant_read_contacts: 'Read contacts',
  grant_create_contact: 'Create contacts',
  grant_delete_contact: 'Delete contacts',
  grant_edit_contact: 'Edit contacts',
  grant_read_personal_files: 'Read personal documents',
  grant_create_personal_file: 'Create personal documents',
  grant_delete_personal_file: 'Delete personal documents',
  grant_edit_personal_file: 'Edit personal documents',
  grant_read_mass_emails: 'Read mass e-mails',
  grant_create_mass_email: 'Create mass e-mails',
  grant_delete_mass_email: 'Delete mass e-mails',
  grant_edit_mass_email: 'Edit mass e-mails',
  grant_read_container_task_requests: 'Read Containertask requests',
  grant_edit_container_task_request: 'Edit Containertask requests',
  grant_trigger_container_task_request_accepted: 'Accept container task',
  grant_trigger_container_task_request_rejected: 'Reject container task',
  grant_trigger_send_mass_email: 'Send mass e-mails',
  grant_trigger_send_task_to_driver: 'Send task to driver',
  grant_trigger_container_task_next_step: 'Send task to next step',
  grant_trigger_rel_numbers_to_check: 'Check release number',
  grant_trigger_con_numbers_to_check: 'Check container number',
  grant_trigger_turnIn_numbers_to_check: 'Check turnIn',
  grant_read_container_task_change_log: 'Read container task changelog',
  grant_read_change_log_companies: 'Read company changelog',
  grant_read_change_log_container_tasks: 'Read container task changelog',
  grant_read_change_log_drivers: 'Read driver changelog',
  grant_read_change_log_vehicles: 'Read vehicle changelog',
  grant_edit_user_companies: 'Change user of a company',
  grant_trigger_container_task_previous_step: 'Container task previous step',
  grant_read_container_planning_events: 'Read containerplanning-events',
  grant_edit_container_planning_event: 'Edit containerplanning-events',
  grant_create_container_planning_event: 'Create containerplanning-events',
  grant_delete_container_planning_event: 'Delete containerplanning-events',
  grant_read_container_planning_files: 'Read containerplanning-files',
  grant_edit_container_planning_file: 'Edit containerplanning-files',
  grant_read_times_of_day_counter: 'Read times of day couter',
  grant_edit_excel_exports: 'Edit excel exports',
  grant_read_excel_exports: 'Read excel exports',
  grant_read_graphs: 'Read graphs',
  grant_read_driver_count: 'Read driver statistics',
  grant_read_subcontractor_count: 'Read subcontractor statistics',
  grant_read_container_count: 'Read container statistics',
  grant_trigger_recount_statistics: 'Trigger recount statistics',
  grant_create_staff: 'Create staff',
  grant_edit_staff: 'Edit staff',
  grant_delete_staff: 'Delete staff',
  grant_read_staffs: 'Read staffs',
  grant_create_staff_file: 'Create staff file',
  grant_edit_staff_file: 'Edit staff file',
  grant_delete_staff_file: 'Delete staff file',
  grant_read_staff_files: 'Read staff files',
  grant_create_staff_salary: 'Create staff salary',
  grant_edit_staff_salary: 'Edit staff salary',
  grant_delete_staff_salary: 'Delete staff salary',
  grant_read_staff_salaries: 'Read staff salaries',
  grant_read_departments: 'Read departments',
  grant_edit_department: 'Edit departments',
  grant_create_department: 'Create departments',
  grant_delete_department: 'Delete departments',
  grant_read_registration_types: 'Read registrations',
  grant_edit_registration_type: 'Edit registrations',
  grant_create_registration_type: 'Create registrations',
  grant_delete_registration_type: 'Delete registrations',
  grant_read_staff_registrations: 'Read staff registrations',
  grant_edit_staff_registration: 'Edit staff registrations',
  grant_create_staff_registration: 'Create staff registrations',
  grant_delete_staff_registration: 'Delete staff registrations',
  grant_read_staff_calendar_birthdays: 'Read birthday calendar',
  grant_read_staff_calendar_contract_end: 'Read contract end calendar',
  grant_edit_container_count: 'Edit container statistics',
  grant_edit_subcontractor_count: 'Edit subcontractor statistics',
  grant_edit_driver_count: 'Edit driver statistics',
  grant_read_truck_count: 'Read truck statistics',
  grant_edit_truck_count: 'Edit truck statistics',
  grant_read_renting: 'Read renting',
  grant_edit_rent: 'Edit renting',
  grant_read_renting_prices: 'Read renting prices',
  grant_edit_renting_price: 'Edit renting prices',
  grant_read_renting_files: 'Read renting files',
  grant_edit_renting_file: 'Edit renting files',
  grant_delete_renting_price: 'Delete renting price',
  grant_edit_driver_task: 'Edit driver task',
  grant_read_driver_tasks: 'Read driver task',
  finish: 'Finish',
  weight_label: 'Weight',
  error_date_to_old: 'Task locked!',
})

export default messages
